/*
* Forgot Password request page javascripts (login/login-reset-password.ftl).
* initValidation() must be called during page initialization.
*/
// eslint-disable-next-line no-var
var ForgotPasswordReqForm = function () {
  this.initValidation = function (regForm) {
    regForm.validate({
      submitHandler: function(form) {
        // eslint-disable-next-line no-undef
        sendFormSubmissionEvent("fp-request", "Reset Your Password Request-"+rhd.config.website_current, form);
        form.submit();
      },
      invalidHandler: function(event, validator) {
        // eslint-disable-next-line no-undef
        sendFormErrorsEvent(regForm[0].id, "fp-request", "Reset Your Password Request-"+rhd.config.website_current, validator);
      },
      rules: {
        "username": {required: true}
      }
    });
    // eslint-disable-next-line no-undef
    sendFormLoadEvent(regForm[0].id, "fp-request", "Reset Your Password Request-"+rhd.config.website_current);
  }
};
// eslint-disable-next-line no-var, no-unused-vars
var forgotPasswordReqForm = new ForgotPasswordReqForm();